import { BrowserRouter } from "react-router-dom";
import RouterSwitch from "./components/routeComponents/RouterSwitch";
import LocationsProvider from "./context/LocationsContext";
import { SnackbarProvider } from "./context/SnackbarContext";
import { SessionContext, SessionProvider } from "./context/SessionContext";
import {
  Modal,
  TreeProviderWrapper,
  ConfirmDialog,
  ApolloClientProvider,
} from "@velocity-ehs/component-library";
import CookieDisclaimer from "./components/routeComponents/Home/CookieDisclaimer";
import { useTranslation } from "react-i18next";
import PublicRouteSwitch, {
  PublicRoutes,
} from "./components/routeComponents/PublicRouteSwitch";
import TopMessage from "./components/sharedComponents/TopMessage";
import UsersService from "@velocity-ehs/user-utils-module";
import { useFlags } from "launchdarkly-react-client-sdk";
import { ReactQueryProvider } from "./context/ReactQueryProvider";

function App() {
  const { t } = useTranslation();
  const { productWorkInProgressBanner } = useFlags();

  if (Object.values(PublicRoutes).includes(window.location.pathname)) {
    return (
      <BrowserRouter>
        <SnackbarProvider>
          <PublicRouteSwitch />
        </SnackbarProvider>
      </BrowserRouter>
    );
  }

  return (
    <ApolloClientProvider>
      <ReactQueryProvider>
        <SessionProvider>
          <LocationsProvider>
            <BrowserRouter>
              <SessionContext.Consumer>
                {({ isLoading, invalidSession }) =>
                  !isLoading && (
                    <div className="mainContent">
                      <ConfirmDialog />
                      <TreeProviderWrapper
                        customerId={UsersService.customer.id}
                      >
                        <SnackbarProvider>
                          {productWorkInProgressBanner && (
                            <TopMessage showLangSelect={false} />
                          )}
                          {!invalidSession && <RouterSwitch />}
                          <CookieDisclaimer
                            userName={UsersService.user?.actualLoginName}
                          />
                          <Modal
                            className="sessionExpired"
                            show={invalidSession}
                            title={t("status_session_expired")}
                            onClose={() =>
                              (window.location.pathname = "/login")
                            }
                            footerButtons={[
                              {
                                label: t("action_okay"),
                                onClick: () =>
                                  (window.location.pathname = "/login"),
                                id: "confirmSessionExpired",
                              },
                            ]}
                          >
                            <p>{t("message_inactivity_security_log_out")}</p>
                          </Modal>
                        </SnackbarProvider>
                      </TreeProviderWrapper>
                    </div>
                  )
                }
              </SessionContext.Consumer>
            </BrowserRouter>
          </LocationsProvider>
        </SessionProvider>
      </ReactQueryProvider>
    </ApolloClientProvider>
  );
}

let customerId = "";

export function setAppCustomerId(id: string) {
  customerId = id;
}

export function getAppCustomerId(): string {
  return customerId;
}

export default App;
